import { css } from '@emotion/core';
import { variables } from '@domain-group/fe-brary';
import { typography } from '@domain-group/fe-co-allhomes-design-system';
var colour = variables.colour;
export var sidebox = {
  name: "1821gv5",
  styles: "display:flex;flex-direction:column;gap:8px;"
};
export var container = /*#__PURE__*/css("display:flex;flex-direction:column;align-items:flex-start;background:", colour.white, ";border:1px solid ", colour.neutral300, ";box-sizing:border-box;");
export var header = /*#__PURE__*/css("display:flex;justify-content:center;align-items:center;width:100%;padding:12px;height:46px;background:", colour.allhomesNavy500, ";");
export var headerText = /*#__PURE__*/css(typography.desktopHeadingM, " color:", colour.white, ";");
export var content = {
  name: "13vmiz3",
  styles: "display:flex;flex-direction:column;align-items:center;padding:0px;position:static;width:320px;height:254.03px;left:0px;top:46px;"
};
export var image = {
  name: "1lxcgia",
  styles: "display:flex;flex-direction:column;justify-content:center;align-items:center;padding:20px 0px 0px;width:160px;"
};
export var contentBottom = {
  name: "162is1w",
  styles: "display:flex;flex-direction:column;align-items:center;padding:16px;"
};
export var contentText = /*#__PURE__*/css(typography.body, " text-align:center;color:", colour.neutral700, ";");
export var button = {
  name: "e4e3sp",
  styles: "margin:12px 0px;justify-content:center;"
};